import { createStaticPropsGetter,Page } from "../libs/pages";

export const getStaticProps = createStaticPropsGetter("mentions-legales");

export default Page;
